import { render, staticRenderFns } from "./_base-slick-carousel.vue?vue&type=template&id=30b49543"
import script from "./_base-slick-carousel.vue?vue&type=script&lang=js"
export * from "./_base-slick-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports